<template>
    <Dialog header="Deleted" v-model:visible="visible" :closable="false"
        :breakpoints="{ '960px': '40vw', '641px': '60vw', '500px': '80vw' }" :style="{ width: '30vw' }" :modal="true">

        <img class="success" src="../../assets/Gif/delete.gif">
        <p class="msg mt-3">{{ $t("confirmation.deletedsuccess") }}</p>
        <template #header>
            <b-container fluid>
                <b-row>
                    <b-col class="d-flex flex-row-reverse">
                        <i class="pi pi-times" @click="$emit('Ok')" />
                    </b-col>
                </b-row>
            </b-container>

        </template>
    </Dialog>
</template>

<script lang="ts">

import { defineComponent, ref } from 'vue'
export default defineComponent({

    props: {

        visible: {
            readonly: false,
            type: Boolean,
            default: ref(false),
            life: 1000
        },

    },
    setup() {

        return {

        }
    },


    methods: {

    }
})

</script>
<style lang="scss" scoped>
.success {
    width: 150px;
    height: 100px;
}
</style>